/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mastercard_card'
export default icon
